"use strict";

require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("Core/Body");
var Languages_1 = require("Core/Languages");
var Notifications_1 = require("Core/Notifications");
var Validation_1 = require("Components/Validation/Validation");
exports.ValidationModule = Validation_1.ValidationModule;
var CartService_1 = require("Components/Cart/CartService");
var Step1Selectors_1 = require("Components/Cart/Step1/Step1Selectors");
var Step2_1 = require("Components/Cart/Step2/Step2");
exports.Step2Component = Step2_1.Step2Component;
var Step2Summary_1 = require("Components/Cart/Step2/Step2Summary");
exports.Step2Summary = Step2Summary_1.Step2Summary;
var Step3_1 = require("Components/Cart/Step3");
exports.Step3Component = Step3_1.Step3Component;
var CartShowMoreBtn_1 = require("Components/Cart/CartShowMoreBtn");
exports.CartShowMoreBtn = CartShowMoreBtn_1.CartShowMoreBtn;
var GuestModal_1 = require("Components/Cart/GuestModal");
exports.GuestModal = GuestModal_1.GuestModal;
var AddCartModal_1 = require("Components/Cart/AddCartModal");
exports.AddCartModal = AddCartModal_1.AddCartModal;
var decimal_js_1 = require("decimal.js");
var CommonFunctions_1 = require("Components/CommonFunctions");
var CartSelector_1 = require("Components/Cart/CartSelector");
var CartCommon_1 = require("Components/Cart/CartCommon");
var Currencies_1 = require("Core/Currencies");
require("jquery.cookie");
exports.Cart = function () {
  var Selector = {
    PRODUCT_TILE: {
      ADD_ITEM: ".js_category_page_add_to_cart"
    },
    PRODUCT_PAGE: {
      ADD_ITEM: ".js_product_page_add_to_cart",
      QUANTITY: ".js_product_page_quantity",
      ADD_OFFER: ".js_product_page_add_to_offer",
      INCREASER: ".js_product_page_quantity--increaser",
      DECREASER: ".js_product_page_quantity--decreaser"
    },
    CATEGORY_PAGE: {
      ADD_ITEM: '.js_category_page_add_to_cart',
      ADD_OFFER: '.js_category_page_add_to_offer',
      QUANTITY: ".js_category_page_quantity",
      INCREASER: ".js_category_page_quantity--increaser",
      DECREASER: ".js_category_page_quantity--decreaser"
    },
    BASKET_PAGE: {
      QUANTITY: ".js_product_quantity_basket",
      COUNT_PRODUCT: ".js_count_product"
    },
    CART: {
      EMPTY_INFO: "#cart_empty",
      DELIVERY_TIME: '#DeliveryTime',
      STEP_3: {
        FORM: '#step3_form',
        FINAL_BUTTON_CART: ".lastStepCartButtonFinal",
        LIGHT_PRELOADER: "#light-preloader",
        FINAL_ORDER_NUMBER: '#final-order-number'
      }
    },
    ORDER_NUMBER: "#final-order-number",
    ORDER_HASH: "#final-order-hash",
    SUMMARY_ORDER: '.js_summary_order'
  };
  var CART_COUNT_LIMIT = 50;
  var Message = {
    MIN_COUNT_LIMIT: "Ilość produktów dodawanych do koszyka musi być większa od 0",
    MAX_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
    CART_COUNT_LIMIT: "W koszyku możesz mieć maksymalnie " + CART_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do koszyka przekracza limit.",
    CART_INVALID_QTY_STEP: "Do koszyka można dodać co najmniej\n XXX YYY tego produktu lub wielokrotność tej ilości"
  };
  var CLEAR_ALL_PRODUCTS = Step1Selectors_1.Step1Selectors.CLEAR_ALL_PRODUCTS,
    PRODUCT = Step1Selectors_1.Step1Selectors.PRODUCT,
    SUMMARY_PANEL = Step1Selectors_1.Step1Selectors.SUMMARY_PANEL,
    RETURN_TO_SHOP_BUTTON = Step1Selectors_1.Step1Selectors.RETURN_TO_SHOP_BUTTON;
  var lang = Languages_1.getCurrentLanguage;
  var HEADER = CartSelector_1.CartSelector.HEADER;
  var triggeredNotification = false;
  function RemoveFromCart() {
    var _a = CartCommon_1.CartCommon.extractCommonData(this),
      $this = _a.$this,
      productId = _a.productId;
    $(this).attr('disabled', 'disabled');
    CartService_1.CartService.remove(lang, productId).done(CartCommon_1.CartCommon.cartChangeHandler).then(function () {
      return updateDeliveryTime();
    }).then(function () {
      return $this.closest(PRODUCT.CONTAINER).remove();
    }).then(function () {
      return CalcProductsQuantity();
    }).then(function () {
      return executeTotalCalculations();
    }).then(function () {
      return recalculateCountRows();
    }).then(function () {
      return recalculateCourierDelivery();
    });
  }
  function ClearAllProductsFromCart() {
    CartService_1.CartService.clear(lang).done(CartCommon_1.CartCommon.cartChangeHandler).then(function () {
      return updateDeliveryTime();
    }).then(function () {
      return calcTotalPrice();
    });
    $(HEADER.QUANTITY_COUNTER).hide().html('0');
    CalcProductsQuantity();
  }
  function ReturnToShopAction() {
    history.go(-1);
    return false;
  }
  function ClearProducts() {
    CartService_1.CartService.clear(lang).done(CartCommon_1.CartCommon.cartChangeHandler).then(function () {
      return calcTotalPrice();
    });
  }
  function IncreaseProdQuantity() {
    var _a = CartCommon_1.CartCommon.extractCommonData(this),
      $this = _a.$this,
      productId = _a.productId;
    var _b = CartCommon_1.CartCommon.extractRowCommonData($this),
      row = _b.row,
      price = _b.price,
      total = _b.total,
      weight = _b.weight,
      totalElementWeight = _b.totalElementWeight,
      unitIsFloat = _b.unitIsFloat;
    var $input = row.find("input[type='number']");
    var _c = CartCommon_1.CartCommon.extractInputCommonData($input),
      quantity = _c.quantity,
      maxQuantity = _c.maxQuantity,
      minQuantity = _c.minQuantity,
      step = _c.step;
    var newValue = quantity.plus(step);
    var newValidValue = CartCommon_1.CartCommon.ValidateProductQuantity(newValue, step, maxQuantity);
    if (quantity.greaterThanOrEqualTo(maxQuantity)) {
      Notifications_1.Notifications.add(Message.MAX_PRODUCT_LIMIT, "info");
      return false;
    } else {
      quantity = new decimal_js_1.Decimal(newValidValue);
      $this.hide();
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        $input.val(quantity.toFixed(unitIsFloat));
        var qty = quantity.toNumber();
        CartCommon_1.CartCommon.showValuesAfterResponse(total, price, qty);
        var totalWeight = CartCommon_1.CartCommon.prepareWeightValues(quantity, weight);
        CartCommon_1.CartCommon.showWeightValues(totalElementWeight, totalWeight);
        $this.show();
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
        executeTotalCalculations();
        recalculateCourierDelivery();
      });
    }
  }
  function DecreaseProdQuantity() {
    var _a = CartCommon_1.CartCommon.extractCommonData(this),
      $this = _a.$this,
      productId = _a.productId;
    var _b = CartCommon_1.CartCommon.extractRowCommonData($this),
      row = _b.row,
      price = _b.price,
      total = _b.total,
      weight = _b.weight,
      totalElementWeight = _b.totalElementWeight,
      unitIsFloat = _b.unitIsFloat;
    var $input = row.find("input[type='number']");
    var _c = CartCommon_1.CartCommon.extractInputCommonData($input),
      quantity = _c.quantity,
      maxQuantity = _c.maxQuantity,
      minQuantity = _c.minQuantity,
      step = _c.step;
    var newValue = quantity.minus(step);
    var newValidValue = CartCommon_1.CartCommon.ValidateProductQuantity(newValue, step, maxQuantity);
    preventNegative(quantity);
    if (quantity.lessThanOrEqualTo(minQuantity)) {
      return false;
    } else {
      if (quantity.lessThanOrEqualTo(0)) {
        $this.val(1);
        quantity = new decimal_js_1.Decimal(1);
      }
      quantity = new decimal_js_1.Decimal(newValidValue);
      $this.hide();
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        $input.val(quantity.toFixed(unitIsFloat));
        var qty = quantity.toNumber();
        CartCommon_1.CartCommon.showValuesAfterResponse(total, price, qty);
        var totalWeight = CartCommon_1.CartCommon.prepareWeightValues(quantity, weight);
        CartCommon_1.CartCommon.showWeightValues(totalElementWeight, totalWeight);
        $this.show();
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
        executeTotalCalculations();
        recalculateCourierDelivery();
      });
    }
  }
  function InputFocusHandler(event) {
    var _a = CartCommon_1.CartCommon.extractCommonData(this),
      $this = _a.$this,
      productId = _a.productId;
    var _b = CartCommon_1.CartCommon.extractRowCommonData($this),
      row = _b.row,
      price = _b.price,
      total = _b.total,
      weight = _b.weight,
      totalElementWeight = _b.totalElementWeight,
      unitIsFloat = _b.unitIsFloat;
    var _c = CartCommon_1.CartCommon.extractInputCommonData($this),
      quantity = _c.quantity,
      maxQuantity = _c.maxQuantity,
      minQuantity = _c.minQuantity,
      step = _c.step;
    var newValidValue = CartCommon_1.CartCommon.ValidateProductQuantity(quantity, step, maxQuantity);
    quantity = new decimal_js_1.Decimal(newValidValue);
    $this.val(quantity.toFixed(0));
    if (quantity.greaterThanOrEqualTo(maxQuantity)) {
      Notifications_1.Notifications.add(Message.MAX_PRODUCT_LIMIT, "info");
      $this.val(maxQuantity);
    } else {
      if (quantity.lessThanOrEqualTo(0) || quantity.isNaN()) {
        $this.val(step);
        quantity = new decimal_js_1.Decimal(step);
      }
      var qty = quantity.toNumber();
      CartCommon_1.CartCommon.showValuesAfterResponse(total, price, qty);
      var totalWeight = CartCommon_1.CartCommon.prepareWeightValues(quantity, weight);
      CartCommon_1.CartCommon.showWeightValues(totalElementWeight, totalWeight);
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        var qty = quantity.toNumber();
        CartCommon_1.CartCommon.setValueOnInput($this, qty);
        CartCommon_1.CartCommon.showValuesAfterResponse(total, price, qty);
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
      });
    }
  }
  function InputKeyupHandler(event) {
    var _a = CartCommon_1.CartCommon.extractCommonData(this),
      $this = _a.$this,
      productId = _a.productId;
    var _b = CartCommon_1.CartCommon.extractRowCommonData($this),
      row = _b.row,
      price = _b.price,
      total = _b.total,
      weight = _b.weight,
      totalElementWeight = _b.totalElementWeight,
      unitIsFloat = _b.unitIsFloat;
    var _c = CartCommon_1.CartCommon.extractInputCommonData($this),
      quantity = _c.quantity,
      maxQuantity = _c.maxQuantity,
      minQuantity = _c.minQuantity,
      step = _c.step;
    var totalWeight;
    if (event.keyCode == 13) {
      return false;
    }
    if (checkIfNotificationWasTriggered(quantity, maxQuantity)) {
      return;
    }
    if (quantity.greaterThanOrEqualTo(maxQuantity)) {
      Notifications_1.Notifications.add(Message.MAX_PRODUCT_LIMIT, "info");
      $this.val(maxQuantity);
      totalWeight = CartCommon_1.CartCommon.prepareWeightValues(maxQuantity, weight);
      CartCommon_1.CartCommon.showWeightValues(totalElementWeight, totalWeight);
    } else {
      if (quantity.lessThanOrEqualTo(0) || quantity.isNaN()) {
        $this.val(step);
        quantity = new decimal_js_1.Decimal(step);
      }
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        var qty = quantity.toNumber();
        CartCommon_1.CartCommon.setValueOnInput($this, qty);
        CartCommon_1.CartCommon.showValuesAfterResponse(total, price, qty);
        totalWeight = CartCommon_1.CartCommon.prepareWeightValues(maxQuantity, weight);
        CartCommon_1.CartCommon.showWeightValues(totalElementWeight, totalWeight);
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
      });
    }
  }
  function checkIfNotificationWasTriggered(quantity, maxQuantity) {
    if (triggeredNotification == true) {
      if (quantity < maxQuantity) {
        triggeredNotification = false;
      } else {
        return true;
      }
    }
    triggeredNotification = quantity == maxQuantity;
    return false;
  }
  function preventNegative(quantity) {
    if (quantity.isZero() && quantity.isNeg()) {
      return quantity = 1;
    }
  }
  function CalcProductsQuantity() {
    var total = $(PRODUCT.CONTAINER).length;
    $(SUMMARY_PANEL.PRODS_QUANTITY).text(total);
  }
  function updateDeliveryTime() {
    CartService_1.CartService.getDeliveryTime().done(function (msg) {
      $(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
    });
  }
  function calcTotalQuantities() {
    var totalQuantity = new decimal_js_1.Decimal(0);
    $(PRODUCT.QUANTITY).each(function () {
      var tempQuantity;
      var unit = new decimal_js_1.Decimal(parseFloat($(this).attr('data-input-step')));
      if (unit.e == 0 && $(this).val() > 0) {
        tempQuantity = new decimal_js_1.Decimal($(this).val());
      } else {
        tempQuantity = new decimal_js_1.Decimal(1);
      }
      if (tempQuantity.isNaN() || tempQuantity < 1) {
        tempQuantity = new decimal_js_1.Decimal(1);
      }
      totalQuantity = totalQuantity.plus(tempQuantity);
    });
    var displayTotalQuantity = totalQuantity.toNumber().toFixed(0);
    $(SUMMARY_PANEL.TOTAL_QUANTITIES).text(displayTotalQuantity.toString());
  }
  function calcTotalPrice() {
    var total = 0;
    var delivery_cost = $(SUMMARY_PANEL.DELIVERY_MIN).data('price');
    $(PRODUCT.TOTAL).each(function () {
      var totalSinglePrice = $(this).attr('data-total-price');
      total += parseFloat(totalSinglePrice);
    });
    CommonFunctions_1.displayValue($(SUMMARY_PANEL.TOTAL), Currencies_1.formatCurrency(total));
    $(SUMMARY_PANEL.TOTAL).data('price', total);
    total += delivery_cost;
    CommonFunctions_1.displayValue($(SUMMARY_PANEL.TOTAL_PLUS_DELIVERY), Currencies_1.formatCurrency(total));
  }
  function checkingProductsInTheBasket(e) {
    e.preventDefault();
    var submitAnswer = CartService_1.CartService.checkProductInTheBasket(lang).done(function (res) {
      if (res.result == false) {
        if (res.redirect != undefined && res.redirect != null) {
          window.location.replace(res.redirect);
        }
        return false;
      } else {
        Body_1.$body.off("submit", Selector.CART.STEP_3.FORM, checkingProductsInTheBasket);
        $(Selector.CART.STEP_3.FORM).submit();
      }
    });
    return false;
  }
  function executeTotalCalculations() {
    calcTotalQuantities();
    calcTotalPrice();
  }
  function finalSubmitOrder(e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    $(Selector.CART.STEP_3.LIGHT_PRELOADER).removeClass("d-none");
    $(Selector.CART.STEP_3.FORM).submit();
  }
  function showButton() {
    setTimeout(function () {
      $(Selector.CART.STEP_3.FINAL_BUTTON_CART).removeClass("d-none");
    }, 500);
  }
  function finalCartFunction() {
    if ($(Selector.CART.STEP_3.FINAL_ORDER_NUMBER).length) {
      var total = 0;
      $(HEADER.VALUE).text(Currencies_1.formatCurrency(total));
      $(HEADER.MAIN_COUNT).hide().html('0');
      $(HEADER.QUANTITY_COUNTER).hide().html('0');
    }
  }
  function sendAjaxRequestWithAcceptOrder() {
    var $orderNumber = $(Selector.ORDER_NUMBER).html();
    var $orderHash = $(Selector.ORDER_HASH).val();
    var urlLang = Languages_1.getCurrentLanguageUrl;
    if ($orderNumber !== undefined && $orderHash !== undefined) {
      $.ajax({
        url: urlLang + "/cart/accept-order/",
        method: 'POST',
        data: {
          order_number: $orderNumber,
          order_hash: $orderHash
        },
        dataType: 'json'
      }).done(function (res) {
        ClearProducts();
      });
    }
  }
  function recalculateCountRows() {
    $(Selector.BASKET_PAGE.COUNT_PRODUCT).each(function (index) {
      index += 1;
      $(this).text(index);
    });
  }
  function recalculateCourierDelivery() {
    var WspolczynnikiTransportowe = [];
    var orderPrice = parseFloat($('#js_order_sum').data('price'));
    if (orderPrice == undefined) {
      orderPrice = 0;
    }
    $(Selector.BASKET_PAGE.QUANTITY).each(function () {
      var productInCourierBox = $(this).data('products-in-courier-box');
      if (productInCourierBox.length != 0 && productInCourierBox != 0) {
        var tempCountThisProductInBox = parseInt(productInCourierBox);
        var tempThisProduct = $(this).val();
        tempThisProduct = parseInt(tempThisProduct);
        if (tempCountThisProductInBox != 0 || tempCountThisProductInBox != undefined) {
          var ilosctmp = tempThisProduct / tempCountThisProductInBox;
          var ilosc = new decimal_js_1.Decimal(ilosctmp).ceil();
          WspolczynnikiTransportowe.push(ilosc);
        }
      }
      if (WspolczynnikiTransportowe.length !== 0) {
        var maxWspolczynnikTransportowy = Math.max.apply(null, WspolczynnikiTransportowe);
        var sumaDostawy = $('#js_sum_delivery_order').data('price');
        var iloscPaczek = parseFloat(sumaDostawy.toFixed(2)) * maxWspolczynnikTransportowy;
        var textSum = 'od ' + iloscPaczek.toFixed(2).replace('.', ',') + ' zł ';
        $('#js_sum_delivery_order').text(textSum);
        var summaryOrder = iloscPaczek + orderPrice;
        var sumartOrderText = summaryOrder.toFixed(2).replace('.', ',') + ' zł';
        $(Selector.SUMMARY_ORDER).text(sumartOrderText);
      }
    });
  }
  $(Selector.CART.STEP_3.FORM).validate({
    rules: {
      agree_rules: 'required',
      agree_data: 'required',
      agree_delivery: 'required',
      agree_payment: 'required'
    }
  });
  Body_1.$body.ready(CalcProductsQuantity);
  Body_1.$body.on("click", CLEAR_ALL_PRODUCTS, ClearAllProductsFromCart);
  Body_1.$body.on("click", RETURN_TO_SHOP_BUTTON, ReturnToShopAction);
  Body_1.$body.on("click", PRODUCT.REMOVE, RemoveFromCart);
  Body_1.$body.on("click", PRODUCT.QUANTITY_CONTROL_INCREASE, IncreaseProdQuantity);
  Body_1.$body.on("click", PRODUCT.QUANTITY_CONTROL_DECREASE, DecreaseProdQuantity);
  Body_1.$body.on("focusout", PRODUCT.QUANTITY, InputFocusHandler);
  Body_1.$body.on("keyup", PRODUCT.QUANTITY, InputKeyupHandler);
  Body_1.$body.on("blur", PRODUCT.QUANTITY, executeTotalCalculations);
  Body_1.$body.on("keyup", PRODUCT.QUANTITY, function () {
    CartCommon_1.CartCommon.InputFocusoutHandler(this);
  });
  Body_1.$body.on("blur", PRODUCT.QUANTITY, function () {
    CartCommon_1.CartCommon.InputFocusoutHandler(this);
  });
  Body_1.$body.on("submit", Selector.CART.STEP_3.FORM, checkingProductsInTheBasket);
  $(window).on("load", showButton);
  Body_1.$body.on("click", Selector.CART.STEP_3.FINAL_BUTTON_CART, finalSubmitOrder);
  $(window).on("load", finalCartFunction);
  $(window).on("load", sendAjaxRequestWithAcceptOrder);
  Body_1.$body.ready(recalculateCourierDelivery);
  Body_1.$body.on("keyup", PRODUCT.QUANTITY, recalculateCourierDelivery);
  Body_1.$body.on("focusout", PRODUCT.QUANTITY, recalculateCourierDelivery);
  Body_1.$body.on("blur", PRODUCT.QUANTITY, recalculateCourierDelivery);
  Body_1.$body.on("change", PRODUCT.QUANTITY, recalculateCourierDelivery);
}();